import type { DraggableSyntheticListeners } from '@dnd-kit/core';
import { createContext } from 'react';

export type TableDragRowContextProps = {
    setActivatorNodeRef?: (element: HTMLElement | null) => void;
    listeners?: DraggableSyntheticListeners;
};

export const TableDragRowContext = createContext<TableDragRowContextProps>({});
